/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-29 15:13:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-29 15:26:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/DisabledSectionTip/index.tsx
 */
import { Icon } from '@/src/tools/icon';
import React from 'react';
import css from './css.module.less';

const Tip = (props) => {
  const { tip, className } = props;
  return (
    <div className={`${css.container} ${className || ''}`}>
      <Icon type='iconinfo2' className={css.icon} />
      {/* Add new page under primary language. */}
      <div className={css.tip}>{tip}</div>
    </div>
  );
};
export default Tip;
